<div
  class="language-select"
  id="language-select"
  data-cy="language-select"
  (click)="togglePopover()"
>
  <p class="language-shorthand">{{ localDisplayName() | uppercase }}</p>
</div>
<markant-popover
  id="select-language-popover"
  data-cy="select-language-popover"
  placement="bottom-start"
  class="language-select-popover"
  for="language-select"
  (backdrop)="closePopover()"
  distance="15"
  [visible]="showPopover"
>
  <markant-list>
    @for (locale of cmsLocales; track $index) {
      <markant-list-item
        [text]="'languageSelect.' + locale.shorthand | transloco"
        [attr.data-cy]="
          'language-selection-' + locale.displayName.toLocaleLowerCase()
        "
        (click)="handleLanguageSelect(locale.shorthand)"
      >
        @if (activeLocale() !== locale.shorthand) {
          <div class="loading-spinner" slot="markant-list-item-trailing">
            @if (loadingLocale() === locale.shorthand) {
              <markant-spinner type="tile" colorScheme="dark"></markant-spinner>
            }
          </div>
        }
        @if (activeLocale() === locale.shorthand) {
          <markant-icon
            slot="markant-list-item-trailing"
            colorScheme="secondary"
            icon="m_checkmark"
          ></markant-icon>
        }
      </markant-list-item>
    }
  </markant-list>
</markant-popover>
